import { z } from "zod";

import { constantsData } from "@/data";

export const setupDataSourceApiConnectionFormSchema = z.object({
    accounts: z.array(z.object({}).passthrough()).min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    name: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    type: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
});
